import Swiper from 'swiper'
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules'
import type { SwiperOptions } from 'swiper/types'

export default function () {
    (() => { // home hero swiper
        const slider = document.querySelector('[data-home-swiper]') as HTMLElement;
        if (!slider) return;

        const isOperakBMW = document.body.classList.contains('site-operak-bmw');
        const mobile = window.matchMedia('(max-width: 47.99rem)'); // mirrors the `sm` SASS breakpoint

        const heroOptions = (): SwiperOptions => ({
            allowTouchMove: document.body.classList.contains('is-mobile'),
            slidesPerView: 1,
            modules: [ Autoplay, Pagination, EffectFade ],
            autoplay: {
                delay: 8000,
            },
            pagination: {
                el: '[data-swiper-pagination]',
                type: 'bullets',
                bulletActiveClass: 'is-active',
                clickable: true
            },
            ...(isOperakBMW && mobile.matches
                ? { effect: 'fade', fadeEffect: { crossFade: true } }
                : { cssMode: true, direction: isOperakBMW ? 'vertical' : 'horizontal' })
        });

        let homeSwiper = new Swiper(slider, heroOptions());

        // Swiper applies `effect`/`cssMode` at init only, so crossing the breakpoint needs a rebuild
        if (isOperakBMW) mobile.addEventListener('change', () => {
            homeSwiper.destroy(true, true);
            homeSwiper = new Swiper(slider, heroOptions());
        });
    })();

    (() => { // home MINI promo swiper
        const promoSection = document.querySelector('[data-promo-swiper]') as HTMLElement;
        if (!promoSection) return;

        const promoSwiper = new Swiper(promoSection, {
            allowTouchMove: document.body.classList.contains('is-mobile'),
            cssMode: true,
            slidesPerView: 1,
            modules: [ Navigation, Pagination ],
            pagination: {
                el: '[data-promo-pagination]',
                type: 'bullets',
                bulletActiveClass: 'is-active',
                clickable: true
            },
            navigation: {
                nextEl: '[data-promo-next]',
                prevEl: '[data-promo-prev]',
                addIcons: false,
            },
        });
    })();
}
